import { ValidationResult, ValidatorOptions } from '.';
import { RequiredValidator } from './required.validator';
import { Validator } from './validator';

export class CurrencyValidator extends Validator {
    public validate(value: string, options: ValidatorOptions) {
        if (!value || value.length < 1) {
            return new RequiredValidator().validate(value, options);
        }

        // Remove currency symbol and commas for validation
        const cleanValue = value.replace(/[$,]/g, '');
        const numValue = parseFloat(cleanValue);

        const valid = !isNaN(numValue) && numValue >= 0;
        if (!valid) {
            return new ValidationResult(false, 'Please enter a valid currency value');
        }

        return new ValidationResult(true);
    }
}
